<script lang="ts" setup>
const { $api } = useNuxtApp()

const { locale } = useI18n()

const currentLocale = computed(() => {
    return locale.value
})
// 1. Reusable type untuk dukungan multi-bahasa
type LocalizedText = {
  en: string;
  id: string;
  [key: string]: string; // Index signature agar aman saat diakses via variabel locale
};

// 2. Interface khusus untuk section ini
interface ISectionData {
  section_title: LocalizedText;
  // Anda bisa menambahkan properti lain di sini nanti, misal:
  // section_subtitle?: LocalizedText;
}

// 3. Implementasi pada data Anda
const sectionData: ISectionData = {
    "section_title": {
        "en": "Trusted by Top Companies",
        "id": "Dipercaya oleh Perusahaan Ternama"
    }
};

const trustedByCompanies = ref<string[]>([]);

const fetchContent = async () => {
    const { data: trustedByCompany } =
        await $api.landingPage.getLpTrustedCompaniesNew()
    trustedByCompanies.value = trustedByCompany.value.data
}

await fetchContent()
</script>

<template>
    <section v-if="trustedByCompanies.length > 0" class="trusted-companies bg-surface text-center ">
        <div class="trusted-companies__header">
            <SectionTitle 
                size="md"
                align="center"
                :title="sectionData.section_title[currentLocale]"
            />
        </div>
        <NuxtMarquee :pauseOnHover="true" :speed="40">
             <VImg
                v-for="(item, index) in trustedByCompanies"
                :key="index"
                :src="item"
                alt="Trusted Company Logo"
                height="90"
                width="200"
                class="mx-5"
                >
            </VImg>
        </NuxtMarquee>
    </section>
</template>

<style lang="scss" scoped>
.trusted-companies {
    @include vwUnit('padding', 80 0 50, 42 0 42);
    padding-inline: 0;

    &__header{
        @include vwUnit('margin-bottom', 40, 32);
    }
}
</style>
